import "@folksam/ui/font/fontFamily.css";

import UIProvider from "@folksam/ui/providers/UIProvider";
import React from "react";
// @ts-ignore:next-line
import ReactDOM from "react-dom";
import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

import App from "./App";

const staleTime = 1000 * 60 * 60 * 24;
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnMount: false,
      refetchOnReconnect: false,
      retry: 2,
      staleTime,
    },
  },
});
const listView = JSON.parse(
  (document.querySelector(".general-config") as HTMLInputElement).value
);
ReactDOM.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <ReactQueryDevtools initialIsOpen={false} />
      <UIProvider>
        <App listView={listView.listView} />
      </UIProvider>
    </QueryClientProvider>
  </React.StrictMode>,
  document.querySelector('[data-folksam-app-id="folksam-test-tables"]')
);
